export const validateUrlRegex = (url: string) => {
  const urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+[^\s]*$/i;
  const result = url.match(urlRegex);
  return result !== null;
};
